import { Avatar, Badge, Dropdown, Icon, Menu, Row, Col, Drawer, Tooltip } from "antd";
import React, { Fragment,useContext,useState } from "react";
import { checkServiceExistance, clearSession, formatFullName, learnMore } from "./helpers/common";
import { NavLink } from "react-router-dom";
import {
  UserIcon,
  SettingIconNew,
  PasswordLockIcon,
  LogoutIcon,
  LinkIcon,
  UpdatesIcon,
} from "./common/CustomIcon";
import closeSvg from "../assets/images/Close.svg";
import rightArrow from "../assets/images/right-arrow.svg";
import manIcon from "../assets/images/manThinking.svg";
// import EditProfile from "./containers/EditProfile";
import { UserContext } from "./context/UserContext";
import useWhatsNew from "./hooks/useWhatsNew";

const formatReleaseVersion = (v) =>
  v ? v.replace(/^V/i, "").split("-")[0] : "";

const SiderFooter = (props) => {
  const { isSuperAdmin, isShipper, isDriver, currentUser, isCollapsed } = props;
  const {fetchCurrentUser} = useContext(UserContext);
  const [visible, setVisible] = useState();
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const { hasUnreadRelease, releases } = useWhatsNew();
  const latestVersionLabel = formatReleaseVersion(releases?.[0]?.versionNumber);
  const showWhatsNewBanner =
    !isCollapsed && hasUnreadRelease && !bannerDismissed && Boolean(latestVersionLabel);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  
  };
  const url = currentUser?.currentOrg?.logo?.url;

  const menu = (isSuperAdmin, isShipper, isDriver) => {
    return (
      <Menu className="sidefooterMenu">
        <div style={{ padding: "0px", marginBottom: "10px" }}>
          <img
            src={url}
            alt="Current Organization logo"
            style={{
              height: "48px",
              width: "168px",
              display: "flex",
              margin: "0 auto",
            }}
          />

          <hr
            style={{
              borderTop: "1px solid #E2E6F5",
              borderBottom: "none",
              marginTop: "10px",
            }}
          />
        </div>
        {checkServiceExistance("UME") && (
          <Menu.Item key="008">
            {/* <a onClick={showDrawer}>
              <UserIcon height={24} width={24} />
              <span className="nav-text marginLeft10 nav-text-side-footer">
                Edit Profile
              </span>
            </a>   */}
            <NavLink to="/edit_profile">
              <UserIcon height={24} width={24} />
              <span className="nav-text marginLeft10 nav-text-side-footer">
                Edit Profile
              </span>
            </NavLink>
          </Menu.Item>
        )}
        {checkServiceExistance("UCP") && (
          <Menu.Item key="009">
            <NavLink to="/changePassword">
              <PasswordLockIcon height={24} width={24} />
              <span className="nav-text marginLeft10 nav-text-side-footer">
                Change Password
              </span>
            </NavLink>
          </Menu.Item>
        )}
        {!isSuperAdmin && !isShipper && !isDriver && (
          <Menu.Item key="010">
            <NavLink to="/displaySettings">
              <SettingIconNew height={24} width={24} />

              <span className="nav-text marginLeft10 nav-text-side-footer">
                Display Settings
              </span>
            </NavLink>
          </Menu.Item>
        )}
          <Menu.Item key="whatsnew">
            <NavLink to="/whats_new">
              {hasUnreadRelease ? (
                <UpdatesIcon height={24} width={24} hasUnreadRelease />
              ) : (
                <UpdatesIcon height={24} width={24} />
              )}
              <span className="nav-text marginLeft10 nav-text-side-footer">
                What's New
              </span>
            </NavLink>
          </Menu.Item>
           <Menu.Item>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                learnMore("academy", currentUser?.id || "");
              }}
            >
              <LinkIcon height={30}width={24}/>
              <span className="nav-text marginLeft10 nav-text-side-footer">
                Fleet Academy
              </span>
            </a>
          </Menu.Item>
        <Menu.Item>
          <a onClick={clearSession}>
            <LogoutIcon height={24} width={24} />
            <span className="nav-text marginLeft10 nav-text-side-footer">
              Sign Out
            </span>
          </a>
        </Menu.Item>
      </Menu>
    );
  };
  return (
    <div
      className={isCollapsed ? "vertical-layout" : "horizontal-layout"}
      style={{ position: "relative" }}
    >
      {showWhatsNewBanner && (
        <div
          style={{
            position: "absolute",
            left: 8,
            right: 8,
            bottom: "calc(100% + 8px)",
            background: "#EEF1FA",
            border: "2px solid #586FCC",
            borderRadius: 8,
            display: "flex",
            alignItems: "center",
            zIndex: 5,
            boxShadow: "0 4px 12px rgba(15, 23, 42, 0.06)",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0, 
            padding: "5px 0 0 10px" }}>
            <span style={{ fontWeight: 600, color: "#1D2540", lineHeight: 2 }}>
              Version {latestVersionLabel}
            </span>
            <NavLink
              to="/whats_new"
              style={{
                color: "#586FCC",
                fontWeight: 500,
                fontSize: 12,
                marginTop: 2,
                marginBottom: 5,
                textDecoration: "none",
                lineHeight: 2,
              }}
            >
              See What's New &nbsp;<img src={rightArrow} alt="Right Arrow" style={{ width: 16 , height: 16 }} />
            </NavLink>
          </div>
          <div style={{ marginTop: "4px" }}>
            <img src={manIcon} alt="Thinking" style={{ width: 50, height: 60 }} />
          </div>
          <div style={{width: "14px"}}>
            <span
              role="button"
              aria-label="Dismiss"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setBannerDismissed(true);
              }}
              style={{
                position: "absolute",
                top: -2,
                right: -2,
                cursor: "pointer",
                color: "#586FCC",
                fontSize: 16,
                lineHeight: 1,
                padding: 4,
              }}
            >
              <img src={closeSvg} alt="Close" style={{ width: 16, height: 16 }} />
            </span>
          </div>
        </div>
      )}
      <Row>
        {/* User Section */}
         <Col  xs={24} className="profile-section"> {/*xs={!isCollapsed ? 19 : 24} */}
          <Dropdown
            overlay={() => menu(isSuperAdmin, isShipper, isDriver)}
            placement="bottomRight"
          >
            <div className="avatar-container">
                <div style={{display:"flex",gap: isCollapsed ? "0px" : "10px" ,alignItems:"center"}}>
                  <Badge dot={hasUnreadRelease} offset={[-4, 4]}>
                    { currentUser?.image?.url ? <Avatar src={`${currentUser.image.url}`}/> : <Avatar icon="user" />}
                  </Badge>
                  {/* &nbsp;&nbsp; */}
                  <div>
                    {!isCollapsed ?  currentUser?.first_name ? formatFullName(currentUser) : "User": <Fragment />}
                  </div>
                </div>
            </div>
          </Dropdown>
        </Col>

        {/* Notification Icon */}
        {/* <Col xs={!isCollapsed ? 5 : 24} className="notification-section">
          <img src={BellIcon} alt="" />
        </Col> */}
      </Row>
      {/* <Drawer

        width="1300px"
        onClose={onClose}
        visible={visible}
        destroyOnClose
      >
        <EditProfile drawerMode onClose={onClose} style={{padding:0}} fetchCurrentUser={fetchCurrentUser}/>
      </Drawer> */}
    </div>
  );
};

export default SiderFooter;